import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest-deep text-cream">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-10 lg:px-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <span className="block h-12 w-12 overflow-hidden rounded-full ring-2 ring-cream/25">
                <img
                  src="/logo.png"
                  alt="Logo L'effet poilus"
                  className="h-full w-full scale-[2.4] object-cover"
                  style={{ transformOrigin: "50% 30%" }}
                />
              </span>
              <span className="font-serif text-2xl font-semibold italic">L'effet poilus</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/60">
              Le coaching familial à travers l'animal. Médiation animale,
              accompagnement à la parentalité et éducation canine — à votre domicile.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sand">Navigation</p>
            <ul className="mt-5 space-y-3 text-sm text-cream/70">
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/methode" data-testid="footer-link-methode">La Méthode</Link></li>
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/prestations" data-testid="footer-link-prestations">Prestations &amp; Tarifs</Link></li>
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/a-propos" data-testid="footer-link-apropos">À propos</Link></li>
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/structures" data-testid="footer-link-structures">Structures &amp; professionnels</Link></li>
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link className="transition-colors duration-200 hover:text-cream" to="/mentions-legales" data-testid="footer-link-mentions">Mentions légales</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sand">Intervention</p>
            <p className="mt-5 text-sm leading-relaxed text-cream/70" data-testid="footer-zone">
              Coutances · Saint-Lô · Granville · Portbail-sur-Mer et les communes alentour — déplacement à votre domicile.
            </p>
            <a
              href="mailto:sophie_reitzer@hotmail.fr"
              className="mt-4 inline-block text-sm font-medium text-sand transition-colors duration-200 hover:text-cream"
              data-testid="footer-email"
            >
              sophie_reitzer@hotmail.fr
            </a>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} L'effet poilus — Tous droits réservés.</p>
          <p className="font-serif italic text-cream/50">« Recréer du lien, une patte à la fois. »</p>
        </div>
      </div>
    </footer>
  );
}
